import Index from './Index.vue';
import { frontendURL } from '../../../helper/URLHelper';
import { KANBAN_VIEW_PERMISSIONS } from 'dashboard/constants/permissions.js';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_board',
    component: Index,
    meta: {
      permissions: ['administrator', 'agent', KANBAN_VIEW_PERMISSIONS],
      secondaryNav: 'kanban',
    },
  },
];
